import { Avatar, AvatarFallback, AvatarImage } from '@journ/ui/avatar'
import { tv, type VariantProps } from '@/libs/tv'

const initials = (name: string): string => {
	const parts = name.trim().split(/\s+/).filter(Boolean)
	if (parts.length === 0) return '?'
	if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase()
	return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
}

const userAvatar = tv({
	base: 'shrink-0',
	variants: {
		size: {
			xs: 'size-5 text-[9px]',
			sm: 'size-6 text-xxs',
			md: 'size-8 text-xs',
			lg: 'size-10 text-sm',
			xl: 'size-16 text-base',
		},
	},
	defaultVariants: { size: 'md' },
})

type Props = VariantProps<typeof userAvatar> & {
	name: string
	avatarUrl?: string | null
	className?: string
}

const UserAvatar = ({ name, avatarUrl, size, className }: Props) => (
	<Avatar className={userAvatar({ size, className })} title={name}>
		{avatarUrl && <AvatarImage src={avatarUrl} alt={name} className='object-cover' />}
		<AvatarFallback className='font-medium'>{initials(name)}</AvatarFallback>
	</Avatar>
)

export { UserAvatar }
